import { sh } from '@tpluscode/rdf-ns-builders';
import ConstraintComponent, { assertTerm } from './ConstraintComponent.js';
export class NodeConstraintComponent extends ConstraintComponent {
    constructor(shape) {
        super(sh.NodeConstraintComponent);
        this.shape = shape;
    }
    static *fromShape(shape, factory) {
        const nodes = shape.get(sh.node) || [];
        for (const node of nodes) {
            assertTerm(node);
            yield new NodeConstraintComponent(factory.nodeShape(node.pointer));
        }
    }
    buildPropertyShapePatterns({ valueNode, variable, ...arg }) {
        const patterns = this.shape.buildConstraints({
            ...arg,
            variable,
            focusNode: valueNode,
            valueNode: variable(),
        });
        if (!patterns.length) {
            return patterns;
        }
        return [{
                type: 'group',
                patterns,
            }];
    }
}
